/**
 * LandingCourses desktop tab-carousel.
 *
 * Markup contract (per `Views/Partials/blocklist/Components/landingCoursesSection.cshtml`):
 *   <div class="amri-hero-desktop">
 *     <div class="amri-hero-carousel-slider-holder">
 *       <div class="slider-thumbnails">
 *         <ul>
 *           <li class="slider-thumbnail-active"><div>ACLS</div></li>
 *           <li><div>PALS</div></li>
 *           <li><div>BLS</div></li>
 *           <li><div>BUNDLE AND SAVE</div></li>
 *         </ul>
 *       </div>
 *       <div class="amri-hero-carousel-slider-wrapper">
 *         <div class="amri-hero-carousel-slider">
 *           <div>... ACLS card ...</div>
 *           <div>... PALS card ...</div>
 *           <div>... BLS card ...</div>
 *           <div>... Bundle card ...</div>
 *         </div>
 *       </div>
 *     </div>
 *   </div>
 *
 * Behavior: click a thumbnail → move `.slider-thumbnail-active` to it + show
 * the card at the same index, hide the others. First-paint default is index 0
 * (ACLS) — the Razor markup already applies `.slider-thumbnail-active` there.
 *
 * Replaces the Phase 3.3 CSS workaround in `v2-overrides.css` that hard-hid
 * `.amri-hero-carousel-slider > div:not(:first-child)`.
 */

const ACTIVE_CLASS = 'slider-thumbnail-active';
const SLIDES_PARENT = '.amri-hero-desktop .amri-hero-carousel-slider';
const THUMBS_PARENT = '.amri-hero-desktop .slider-thumbnails';

function showOnlyCardAt(slides: HTMLCollection, index: number): void {
    for (let i = 0; i < slides.length; i++) {
        const el = slides[i] as HTMLElement;
        el.style.display = i === index ? '' : 'none';
    }
}

function setActiveThumb(thumbs: HTMLLIElement[], index: number): void {
    thumbs.forEach((li, i) => {
        li.classList.toggle(ACTIVE_CLASS, i === index);
    });
}

export function initCarousel(): void {
    const slider = document.querySelector<HTMLElement>(SLIDES_PARENT);
    const thumbsList = document.querySelector<HTMLElement>(THUMBS_PARENT);
    if (!slider || !thumbsList) {
        // Page doesn't have the LandingCourses block; nothing to do.
        return;
    }
    const slides = slider.children;
    const thumbs = Array.from(thumbsList.querySelectorAll<HTMLLIElement>('li'));
    if (slides.length === 0 || thumbs.length === 0) {
        return;
    }

    const initialIndex = Math.max(
        0,
        thumbs.findIndex(li => li.classList.contains(ACTIVE_CLASS))
    );
    showOnlyCardAt(slides, initialIndex);

    thumbs.forEach((li, i) => {
        li.addEventListener('click', () => {
            setActiveThumb(thumbs, i);
            showOnlyCardAt(slides, i);
        });
    });
}
